export function generateFreeLinkURL(
  freeLinkURL: string | undefined,
  appAlias: string
) {
  const url = new URL(freeLinkURL || 'https://elfsight.com');
  return setUTM(url, 'free-widget', appAlias);
}

export function generateFreeLinkRemoveURL(
  freeLinkRemoveURL: string | undefined,
  appAlias: string
) {
  const url = new URL(
    freeLinkRemoveURL || `https://dash.elfsight.com/apps/${appAlias}/pricing`
  );
  return setUTM(url, 'remove-link', appAlias);
}

function setUTM(
  url: URL,
  campaign: 'free-widget' | 'remove-link',
  appAlias: string
) {
  const utmParams = {
    utm_source: 'websites',
    utm_medium: 'clients',
    utm_term: resolveCurrentHostname(),
    utm_content: appAlias,
    utm_campaign: campaign
  };

  Object.entries(utmParams).map(([key, value]) => {
    if (value) {
      url.searchParams.set(key, value);
    }
  });

  return url;
}

// @TODO move into lib
function resolveCurrentHostname() {
  try {
    const isIframe = window.self !== window.top;

    let targetUrl: string;

    if (isIframe) {
      targetUrl = document.referrer || window.location.href;
    } else {
      targetUrl = window.location.href;
    }

    const url = new URL(targetUrl);

    return url.hostname;
  } catch {
    try {
      return window.location.hostname;
    } catch {
      return undefined;
    }
  }
}
